// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили */
.transpos-subtitle {
  display: grid;
  font-size: 2vw;
  place-self: center;
}
.transpos-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.transpos-logoRun {
  height: 2.1vw;
  place-self: center;
}
.transpos-Scene {
  display: flex;
  margin-right: 9.4vw;
  flex-direction: column;
  gap: 2vw;
}

/* Логотип с кнопками и таймером */

.transpos-board-content {
  display: grid;
  grid-template-columns: 20vw auto;
  gap: 0.4vw;
}

.transpos-board-logo {
  display: grid;
  position: relative;
  right: 3vw;
  grid-template-rows: 24vw 3vw 3vw;
  gap: 1vw;
  place-content: end;
}

.transpos-board-logo-image {
  position: relative;
  height: 24vw;
}

#transpos-board-logo-button {
  position: relative;
  left: 1.5vw;
}

#transpos-subtitle-board-logo {
  position: relative;
  left: 1.5vw;
}
/* основное поле */
.transpos-board-game {
  display: flex;
  gap: 2.4vw;
}
.transpos-board-wrapper {
  display: grid;
  grid-template-rows: auto 3vw;
  gap: 1vw;
}
/* левое поле с загадкой и кнопкой */
.transpos-board-area {
  position: relative;
  height: 100%;
  background: white;
  border: 0.15vw #1a6a7c solid;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
  aspect-ratio: 1/1;
  perspective: 1000px;
}
.transpos-board-grid {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: repeat(10, 1fr);
}
.transpos-text-line {
  display: flex;
  align-items: center;
  padding-left: 0.8vw;
  font-size: 2vw;
  border-bottom: 0.05vw solid #1a6a7c;
}

.transpos-divider {
  color: #2aa7a7;
}
/* правое поле с расшифровкой, кнопкой и полем для проверки отгадки */
.transpos-input-board-wrapper {
  display: flex;
  gap: 1vw;
  flex-direction: column;
}
.transpos-grid-area {
  display: grid;
  height: 100%;
  grid-template-rows: repeat(10, 1fr);
  background-color: #ffffff;
  border: 0.15vw #1a6a7c solid;
  aspect-ratio: 1/1;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}
.transpos-input-area {
  display: grid;
  grid-template-columns: auto 2.2vw;
  gap: 0.4vw;
}
.transpos-controls {
  display: grid;
  height: 100%;
  grid-template-rows: repeat(10, 1fr);
}
.transpos-button-input-board {
  display: grid;
  gap: 0.4vw;
  grid-template-columns: auto 15.5vw 2.2vw;
}

.transpos-input-line {
  display: flex;
  align-items: center;
  padding-left: 0.8vw;
  font-size: 2vw;
  outline: none;
  border: none;
  border-bottom: 0.1vw solid #1a6a7c;
  border-radius: 0;

  background: transparent;
}
.transpos-input {
  padding-left: 0.8vw;
  font-size: 2vw;
  height: 3vw;
  background-color: #ffffff;
  outline: none;
  text-transform: uppercase;
  border: 0.1vw #1a6a7c solid;
  border-radius: 0.6vw;
}

.transpos-active {
  background: #e6f3ff;
}

.transpos-wrong {
  background: #ffc0c0;
}

.transpos-correct {
  background: #e6ffe6;
}
.transpos-card {
  position: relative;
  width: 100%;
  height: 100%;

  transition: transform 2s;
  transform-style: preserve-3d;
}

.transpos-card-flipped {
  transform: rotateY(180deg);
}

.transpos-card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
}

.transpos-card-front {
  background: white;
}

.transpos-card-back {
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}

.transpos-win-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Transposition/styles/TransposBoard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,QAAQ;AACV;AACA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B;;mCAEiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;AACA,qEAAqE;AACrE;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB;;mCAEiC;AACnC;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;;EAEhB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Общие стили */\n.transpos-subtitle {\n  display: grid;\n  font-size: 2vw;\n  place-self: center;\n}\n.transpos-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.transpos-logoRun {\n  height: 2.1vw;\n  place-self: center;\n}\n.transpos-Scene {\n  display: flex;\n  margin-right: 9.4vw;\n  flex-direction: column;\n  gap: 2vw;\n}\n\n/* Логотип с кнопками и таймером */\n\n.transpos-board-content {\n  display: grid;\n  grid-template-columns: 20vw auto;\n  gap: 0.4vw;\n}\n\n.transpos-board-logo {\n  display: grid;\n  position: relative;\n  right: 3vw;\n  grid-template-rows: 24vw 3vw 3vw;\n  gap: 1vw;\n  place-content: end;\n}\n\n.transpos-board-logo-image {\n  position: relative;\n  height: 24vw;\n}\n\n#transpos-board-logo-button {\n  position: relative;\n  left: 1.5vw;\n}\n\n#transpos-subtitle-board-logo {\n  position: relative;\n  left: 1.5vw;\n}\n/* основное поле */\n.transpos-board-game {\n  display: flex;\n  gap: 2.4vw;\n}\n.transpos-board-wrapper {\n  display: grid;\n  grid-template-rows: auto 3vw;\n  gap: 1vw;\n}\n/* левое поле с загадкой и кнопкой */\n.transpos-board-area {\n  position: relative;\n  height: 100%;\n  background: white;\n  border: 0.15vw #1a6a7c solid;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n  aspect-ratio: 1/1;\n  perspective: 1000px;\n}\n.transpos-board-grid {\n  display: grid;\n  width: 100%;\n  height: 100%;\n  grid-template-rows: repeat(10, 1fr);\n}\n.transpos-text-line {\n  display: flex;\n  align-items: center;\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  border-bottom: 0.05vw solid #1a6a7c;\n}\n\n.transpos-divider {\n  color: #2aa7a7;\n}\n/* правое поле с расшифровкой, кнопкой и полем для проверки отгадки */\n.transpos-input-board-wrapper {\n  display: flex;\n  gap: 1vw;\n  flex-direction: column;\n}\n.transpos-grid-area {\n  display: grid;\n  height: 100%;\n  grid-template-rows: repeat(10, 1fr);\n  background-color: #ffffff;\n  border: 0.15vw #1a6a7c solid;\n  aspect-ratio: 1/1;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n.transpos-input-area {\n  display: grid;\n  grid-template-columns: auto 2.2vw;\n  gap: 0.4vw;\n}\n.transpos-controls {\n  display: grid;\n  height: 100%;\n  grid-template-rows: repeat(10, 1fr);\n}\n.transpos-button-input-board {\n  display: grid;\n  gap: 0.4vw;\n  grid-template-columns: auto 15.5vw 2.2vw;\n}\n\n.transpos-input-line {\n  display: flex;\n  align-items: center;\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  outline: none;\n  border: none;\n  border-bottom: 0.1vw solid #1a6a7c;\n  border-radius: 0;\n\n  background: transparent;\n}\n.transpos-input {\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  height: 3vw;\n  background-color: #ffffff;\n  outline: none;\n  text-transform: uppercase;\n  border: 0.1vw #1a6a7c solid;\n  border-radius: 0.6vw;\n}\n\n.transpos-active {\n  background: #e6f3ff;\n}\n\n.transpos-wrong {\n  background: #ffc0c0;\n}\n\n.transpos-correct {\n  background: #e6ffe6;\n}\n.transpos-card {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  transition: transform 2s;\n  transform-style: preserve-3d;\n}\n\n.transpos-card-flipped {\n  transform: rotateY(180deg);\n}\n\n.transpos-card-face {\n  position: absolute;\n  inset: 0;\n  backface-visibility: hidden;\n}\n\n.transpos-card-front {\n  background: white;\n}\n\n.transpos-card-back {\n  transform: rotateY(180deg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n}\n\n.transpos-win-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
